<script>
import moment from 'moment';
import FormGuideSelectionStats from '../FormGuideSelectionStats/FormGuideSelectionStats.vue';
export default {
  name: 'SelectionStats',
  components: {
    FormGuideSelectionStats,
  },
  props: {
    selection: {
      type: Object,
      required: true,
    },
  },
  computed: {
    competitor() {
      return this.selection.competitor || {};
    },
    jockey() {
      return this.selection.jockey || {};
    },
    trainer() {
      return this.selection.trainer || {};
    },
    stats() {
      return this.selection.stats || {};
    },
    foaledDate() {
      const date = moment
        .utc(this.competitor.foal_date)
        .local()
        .format('DD-MM-YYYY');

      return date;
    },
  },
};
</script>

<template>
  <div class="selection-stats-card">
    <!-- stat card header -->
    <div class="selection-stats-card__header">
      <div class="selection-stats-card__header-left">
        <div class="selection-stats-card__header-item silk">
          <img :src="selection.silk_image_url_medium" >
        </div>
        <div class="selection-stats-card__header-item competitor">
          <div
            class="selection-stats-card__competitor-name"
          >{{ selection.competitor_number }}. {{ competitor.name }} ({{ selection.barrier_number }})</div>
          <div class="selection-stats-card__competitor-name-details">
            <div class="selection-stats-card__competitor-name-detail">
              <span class="highlight">F:</span>
              {{ stats.lastSixFigure }}
            </div>
            <div class="selection-stats-card__competitor-name-detail">
              <span class="highlight">T:</span>
              {{ trainer.short_name }}
            </div>

            <div class="selection-stats-card__competitor-name-detail">
              <span class="highlight">D:</span>
              {{ jockey.short_name }}
            </div>
          </div>
        </div>
      </div>
      <div class="selection-stats-card__header-right">
        <div class="selection-stats-card__competitor-info">
          <div class="selection-stats-card__info-container">
            <div class="selection-stats-card__info-header">COLOUR</div>
            <div class="selection-stats-card__info-details">{{ competitor.colour }}</div>
          </div>
          <div class="selection-stats-card__info-container">
            <div class="selection-stats-card__info-header">AGE/SEX</div>
            <div
              class="selection-stats-card__info-details"
            >{{ competitor.age }}yo {{ competitor.sex }}</div>
          </div>
          <div class="selection-stats-card__info-container">
            <div class="selection-stats-card__info-header">OWNERS</div>
            <div class="selection-stats-card__info-details limit-three-lines">{{ competitor.owner }}</div>
          </div>
          <div class="selection-stats-card__info-container">
            <div class="selection-stats-card__info-header">FOALED</div>
            <div class="selection-stats-card__info-details">{{ foaledDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="selection-stats-card__stats">
      <template v-if="stats">
        <FormGuideSelectionStats :stats="stats" :race-type="`harness`" :is-mobile="false" />
      </template>
    </div>
  </div>
</template>
